import { toast } from 'sonner';

import { API_URL } from '@/config';

export const steamLogin = () => {
  try {
    const currentPath = window.location.pathname + window.location.search;
    window.location.href = `${API_URL}/v1/auth/steam?origin=${encodeURIComponent(
      currentPath,
    )}`;
  } catch (error) {
    toast.error('Failed to initiate Steam login');
  }
};

export const useSteamLogin = () => {
  const handleSteamError = (error: string) => {
    toast.error(error || 'Failed to authenticate with Steam');
  };

  return {
    login: steamLogin,
    handleError: handleSteamError,
  };
};
